import { render, staticRenderFns } from "./NimbusDrive.vue?vue&type=template&id=f51b1604&scoped=true&"
import script from "./NimbusDrive.vue?vue&type=script&lang=js&"
export * from "./NimbusDrive.vue?vue&type=script&lang=js&"
import style0 from "./NimbusDrive.vue?vue&type=style&index=0&id=f51b1604&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51b1604",
  null
  
)

export default component.exports